/**
 * 颜色标签 → URL 片段的统一归一化规则。
 *
 * 商品变体链接形如 `{url_key}-{color}.html`，颜色标签会直接拼进路径。
 * 早期实现只把空格替换成连字符，于是 "Red/Blue/Green" 这类多色标签
 * 会产出 `-red/blue/green`，斜杠被当成路径分隔符，链接直接 404。
 *
 * 生成端（商品卡片链接）与解析端（[...resolver] 按 URL 反查颜色）必须共用本函数，
 * 否则会出现 URL 能生成、但匹配不回对应颜色变体的情况。
 */
export function normalizeColorLabel(value?: string | null): string {
  return (value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
